/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EventResponse } from './eventResponse';
import { TenantRequestAccessSpec } from './tenantRequestAccessSpec';
import { RequestAccessStatusEnum } from './requestAccessStatusEnum';


export interface TenantOrgAccessRecord { 
    event: EventResponse;
    /**
     * Access Request id
     */
    request_id: string;
    request_status: RequestAccessStatusEnum;
    /**
     * Time at which Request was submitted
     */
    request_time: Date;
    /**
     * User who created the request
     */
    requested_by: string;
    spec: TenantRequestAccessSpec;
}
export namespace TenantOrgAccessRecord {
}


